<template>
  <div class="comp-list-view" v-loading="loading == -1">
    <div v-if="dataArr.length > 0" class="comp-list-con-div" style="padding-top: 10px">
      <div class="comp-list-con">
        <comp-card
          :data="item"
          type="comp"
          v-for="(item, index) of dataArr"
          :key="index"
          @mouseover="_cardMouseover(item, index)"
        >
          <template #footer>
            <div class="edit-view">
              <span v-if="item.Exist" class="exist-span">已加入我的供应链</span>
              <i class="drag-edit" title="可拖拽放置指定的目录中" v-else><svg-drag :width="18" :height="18" fill="#ffffff"></svg-drag></i>
            </div>
          </template>
        </comp-card>

        <!-- <div class="recommn-btn att-rec-btn" @click="compRecommOpen">
          <i class="el-icon-plus"></i>
          推荐我需要的优秀供应商
        </div> -->

        <div class="comp-card-empty" v-for="item of 20" :key="`key_${item}`"></div>

      </div>

    </div>

    <el-empty description="暂无供应商" v-else>
      <el-button type="text" @click="compRecommOpen"><span class="att-rec-btn">推荐我需要的优秀供应商</span></el-button>
    </el-empty>

    <div class="list-pagination">
      <md-page :page="page" :total="total" :pageSize="pageSize" @pagecallback="handleCurrentChange"></md-page>
    </div>

    <class-composes @cidChange="vipCompanyCidChange"></class-composes>
  </div>
</template>

<script>
//引入服务
import {AdvertsType,AdvertsService} from '@digital-supply-chain/module'
import {CompService,DragService} from "@/service";
import {UtilService,Category} from "@/libs";

import CompCard from "@/components/comp-card.vue";
import SvgDrag from '@/components/svg/drag.vue';

import ClassComposes from './class-composes.vue';

export default{
  components: { CompCard, ClassComposes, SvgDrag },
  data() {
    return {
      advertsList: [],
      dataList: [],
      vipCompanyCid: 1,
      loading: 0, //状态  -1加载中 0 未加载  1 加载完成

      page: 1,
      pageSize: 51,
      total: 0,
    }
  },
  computed: {
    dataArr() {
      return this.advertsList.concat(this.dataList);
    }
  },
  methods: {
    resetList() {
      this.vipCompanyCid = 1;
      this.page = 1;
      this.dataList = [];
      this.advertsList = [];
      this.vipAdvertsComps();
    },

    // 广告
    async vipAdvertsComps() {
      this.loading = -1;
      const levelName = {
        '金牌': 32,
        '银牌': 4,
        '铜牌': 2,
        '仅认证': 0,
      };
      let res = await AdvertsService.queryAdverts({
        type: AdvertsType.GoldRecommend,
        limit: 20,
        random: true,
      });
      this.loading = 1;
      res = res || [];
      res.forEach((item, index) => {
        item.CompVipLevel = levelName[item.level];
        item = UtilService.returnJrzzComObj(item);
        item.DirID = -1;
        item.isAdd = true;
        item.Exist = null;
        item.index = index;
      });
      this.advertsList = res;
      this.vipCompanyList();
    },

    // 分页搜素
    handleCurrentChange(_page) {
      this.page = _page.page;
      this.dataList = [];
      this.vipCompanyList();
    },
    async vipCompanyList(){
      this.loading = -1;
      CompService.getVipCompanyList(
        '',
        this.vipCompanyCid,
        this.page,
        this.pageSize
      ).then(res => {
        if (res.code === 0) {
          res.data.list.forEach((item, index) => {
            item = UtilService.returnJrzzComObj(item);
            item.DirID = -1;
            item.isAdd = true;
            item.Exist = null;
            item.index = index;
          });
          this.total = res.data.count;
          this.dataList = res.data.list;
          this.initDrag(this.dataArr);
        }
        this.loading = 1;
      })
    },

    _cardMouseover(item, index) {
      if (item.ResID || item.Exist) return false;
      if (item.Exist === null) {
        CompService.enterpriseExist(item.CompID, true).then(res => {
          if (res) {
            this.dataArr[index].Exist = true;
          } else {
            this.dataArr[index].Exist = false;
          }
        }).catch(() => {
          this.dataArr[index].Exist = false;
        });
      }
    },

    vipCompanyCidChange(cid = 1) {
      this.page = 1;
      this.vipCompanyCid = cid;
      this.dataList = [];
      this.vipCompanyList();
    },

    compRecommOpen() {
      this.$parent.compRecommOpen()
    },

    initDrag(datas = this.dataArr) {
      this.$nextTick(() => {
        DragService.dragToTree({
          table: document.getElementsByClassName('attention-container')[0],
          wrapper: '.comp-list-con',
          handle: ".drag-edit",
          delay: 1,
          filter: '.comp-list2',
          primaryKey: "ResID",
          datas,
          category: Category.Enterprise,
          callback: this.dragCallback,
          dirCategory: Category.EnterpriseDir,
          operateAreaId: [Category.EnterpriseDir,Category.EnterpriseDirShare],
        })
      })
    },
    dragCallback(args) {
      args.row.index && (this.dataArr[args.row.index].Exist = true)
      this.$parent.dragDataCallback(args.treeId, args.treeDirCategoryId, 0, args.dirCategoryId, args.copy);
    },
  },
}
</script>

<style lang="less" scope>
.comp-list-view{
  display: flex;

  .list-pagination{
    position: absolute;
    left: 0;
    bottom: 0;
    width: calc(100% - 230px);
    background: #ffffff;
  }

  /deep/ .el-empty{
    flex: 1;
  }

  .recommn-btn{
    border: 1px solid #E6F3F9;
    min-width: 230px;
    max-width: 280px;
    margin: 0 5px 10px 5px;
    flex: 1;
    color: #0989C5;
    font-size: 15px;
    font-weight: bold;
    background: #E6F3F9;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 70px;
    i{
      font-weight: bold;
      margin-right: 3px;
    }
  }
}
.comp-list-con-div{
  flex: 1;
  height: calc(100vh - 20px - 43px);
  overflow-y: auto;
}
.comp-list-con{
  display: flex;
  flex-wrap: wrap;
  padding: 10px 5px;
  flex: 1;
}
.edit-view{
  position: absolute;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  opacity: 0;
  transform: translateY(26px);
  transition: all 0.4s;
  i{
    width: 26px;
    height: 26px;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .exist-span{
    width: 120px;
    height: 26px;
    color: #fff;
    font-size: 13px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .drag-edit{
    cursor: move;
  }
}
.comp-list-con{
  /deep/ .list-card:hover .edit-view{
    opacity: 1;
    transform: translateY(0px);
  }
}
</style>
